(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/announcement/views/announcement.js') >= 0) return;  svs.modules.push('/widgets/announcement/views/announcement.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.widget=_svs.widget||{};
_svs.widget.announcement=_svs.widget.announcement||{};
_svs.widget.announcement.templates=_svs.widget.announcement.templates||{};
svs.widget.announcement.templates.announcement = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "  <div class=\"widget-default padding-0 margin-0\" data-widget=\"announcement\"></div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"currentWidget") : depth0),{"name":"with","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":4,"column":9}}})) != null ? stack1 : "");
},"useData":true});
Handlebars.partials['widget-announcement-announcement'] = svs.widget.announcement.templates.announcement;
})(svs, Handlebars);


 })(window);